import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { Coordinate } from "ol/coordinate";

const useViewUrlSync = () => {
  const [, setSearchParams] = useSearchParams();

  const setCenterUrl = useCallback(
    (center: number[]) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("center", `${center[0]},${center[1]}`);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const setZoomUrl = useCallback(
    (zoom: number) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("zoom", String(zoom));
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const setViewUrl = useCallback(
    (center: Coordinate, zoom: number) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("center", `${center[0]},${center[1]}`);
          next.set("zoom", String(zoom));
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return { setCenterUrl, setZoomUrl, setViewUrl };
};

export default useViewUrlSync;
